const state = {
  account: null,
  accountStatus: null,
  accountDetails: null,
  firstname: null,
  firstnameDirty: false,
  lastname: null,
  lastnameDirty: false,
  country: null,
  countryDirty: false,
  language: null,
  languageDirty: false,
  telephone: null,
  telephoneDirty: false,
  company: null,
  companyDirty: false,
  email: null,
  helpdesk: false,
  helpdeskDirty: false,
  accountTimeZoneOffset: 0
};

const getters = {
  account: state => {
    return state.account;
  },
  accountStatus: state => {
    return state.accountStatus;
  },
  accountDetails: state => {
    return state.accountDetails;
  },
  userId: state => {
    return state.account ? state.account.userId : null;
  },
  username: state => {
    return state.firstname + " " + state.lastname;
  },
  firstname: state => {
    return state.firstname;
  },
  firstnameDirty: state => {
    return state.firstnameDirty;
  },
  lastname: state => {
    return state.lastname;
  },
  lastnameDirty: state => {
    return state.lastnameDirty;
  },
  country: state => {
    return state.country;
  },
  countryDirty: state => {
    return state.countryDirty;
  },
  language: state => {
    return state.language;
  },
  languageDirty: state => {
    return state.languageDirty;
  },
  telephone: state => {
    return state.telephone;
  },
  telephoneDirty: state => {
    return state.telephoneDirty;
  },
  company: state => {
    return state.company;
  },
  companyDirty: state => {
    return state.companyDirty;
  },
  email: state => {
    return state.email;
  },
  helpdesk: state => {
    return state.helpdesk;
  },
  helpdeskDirty: state => {
    return state.helpdeskDirty;
  },
  accountTimeZoneOffset: state => {
    return state.accountTimeZoneOffset;
  }
};

const mutations = {
  account: (state, account) => {
    state.account = account;
    state.firstname = account ? account.firstName : null;
    state.lastname = account ? account.lastName : null;
    state.email = account ? account.email : null;
  },
  accountStatus: (state, accountStatus) => {
    state.accountStatus = accountStatus;
    state.helpdesk = accountStatus ? accountStatus.allowsHelpdesk : null;
  },
  accountDetails: (state, accountDetails) => {
    state.accountDetails = accountDetails;
    state.country = accountDetails ? accountDetails.country : null;
    state.language = accountDetails ? accountDetails.language : null;
    state.telephone = accountDetails ? accountDetails.phone : null;
    state.company = accountDetails ? accountDetails.companyName : null;
  },
  firstname: (state, newValue) => {
    state.firstname = newValue;
    state.firstnameDirty = true;
  },
  firstnameDirty: (state, newValue) => {
    state.firstnameDirty = false;
  },
  lastname: (state, newValue) => {
    state.lastname = newValue;
    state.lastnameDirty = true;
  },
  lastnameDirty: (state, newValue) => {
    state.lastnameDirty = false;
  },
  country: (state, newValue) => {
    state.country = newValue;
    state.countryDirty = true;
  },
  countryDirty: (state, newValue) => {
    state.countryDirty = false;
  },
  language: (state, newValue) => {
    state.language = newValue;
    state.languageDirty = true;
  },
  languageDirty: (state, newValue) => {
    state.languageDirty = false;
  },
  telephone: (state, newValue) => {
    state.telephone = newValue;
    state.telephoneDirty = true;
  },
  telephoneDirty: (state, newValue) => {
    state.telephoneDirty = false;
  },
  company: (state, newValue) => {
    state.company = newValue;
    state.companyDirty = true;
  },
  companyDirty: (state, newValue) => {
    state.companyDirty = false;
  },
  email: (state, newValue) => {
    state.email = newValue;
  },
  helpdesk: (state, newValue) => {
    state.helpdesk = newValue;
    state.helpdeskDirty = true;
  },
  helpdeskDirty: (state, newValue) => {
    state.helpdeskDirty = false;
  },
  SET_ACCOUNT_TIMEZONE: (state, newValue) => {
    state.accountTimeZoneOffset = newValue;
  }
};

const actions = {
  account({ commit }, account) {
    commit("account", account);
  },
  accountDetails({ commit }, accountDetails) {
    commit("accountDetails", accountDetails);
  },
  accountTimeZoneOffset({ commit }, timeZone) {
    commit("SET_ACCOUNT_TIMEZONE", timeZone);
  },
  
};

export default {
  state,
  getters,
  mutations,
  actions
};
